import { DependencyList, useCallback, useState } from 'react'

export function useCallbackWithForceRefresh<T extends (...args: any[]) => any>(
  callback: T,
  deps: DependencyList
): {
  callback: T
  forceRefresh: (skipLoadingFlag?: boolean) => void
  skipLoadingFlag: boolean
} {
  const [refresher, setRefresher] = useState({
    skipLoadingFlag: false,
    trigger: 0,
  })

  return {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    callback: useCallback(callback, [...deps, refresher]),
    forceRefresh: useCallback(
      (skipLoadingFlag?: boolean) => {
        setRefresher((r) => ({
          skipLoadingFlag: skipLoadingFlag || false,
          trigger: r.trigger + 1,
        }))
      },
      [setRefresher]
    ),
    skipLoadingFlag: refresher.skipLoadingFlag,
  }
}
